
export const getAccessToken = (user) => {
  if (!user) return;
  const accessToken = user.access_token;
  const idToken = user.id_token;
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("idToken", idToken);
};

export const getUserId = () => {
  const userId = localStorage.getItem("userId");
  return userId;
};

export const getIdToken = () => {
  const accessToken = localStorage.getItem("accessToken");
  const idToken = localStorage.getItem("idToken");
  return { token: idToken, idToken: accessToken };
};

export const getImpersonatedUser = async () => {
  return localStorage.getItem("impersonated");
};

export const getRoles = (user) => {
  const delegatedUser = localStorage.getItem("impersonated");
  if (delegatedUser) {
    const decodedUser = JSON.parse(atob(delegatedUser));
    console.log(decodedUser);
    return normalizeRoles(decodedUser.roleId);
  }

  // const roles = JSON.parse(user.signInUserSession.idToken.payload.roles);
  // const roles = JSON.parse(user?.profile?.roles);
  // const roleIds = roles.map((role) => role.id)
  // return roleIds;
  // const adminRole = roles.find((role) => {
  //   return role.id === "SEC-IDM-CODES-ADMIN";
  // });
  // if (adminRole) {
  //   return adminRole.id;
  // } else {
  //   return roles[0].id;
  // }

  return normalizeRoles(user?.profile?.roles);
};

const normalizeRoles = (roles) => {
  if (Array.isArray(roles)) return roles;
  if (typeof roles === "string") return [roles];
  return [];
};

export const prepareRole = (roles) => {
  let roleIds = [];
  (roles || []).forEach((role) => {
    roleIds.push({ id: role, name: role });
  });
  return roleIds;
}

